import { render, staticRenderFns } from "./label-dropdown.vue?vue&type=template&id=6ce7e0af&scoped=true&"
import script from "./label-dropdown.vue?vue&type=script&lang=ts&"
export * from "./label-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./label-dropdown.vue?vue&type=style&index=0&id=6ce7e0af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce7e0af",
  null
  
)

export default component.exports